import axios from "axios";

import { TextMessage, Trove } from "./types";

// Formats integer cents as a USD string, e.g. 12345 -> "$123.45".
export const formatCents = (cents: number): string =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format((cents || 0) / 100);

// Converts a dollar amount (from an input) to integer cents. The payment endpoint asserts int.
export const toCents = (value: number | string | null): number => Math.round((Number(value) || 0) * 100);

// The trove id lives on the owner properties, not on selectedCustomer.
export const getSmsTroveId = async (customerId: string): Promise<string | null> => {
  const res = await axios.get("/api/getOwnerProperties", { params: { customer_id: customerId } });
  return res.data?.owner_properties?.sms_trove ?? null;
};

export const getTroveParams = async (troveId: string): Promise<Trove> => {
  const res = await axios.post("/api/getTroveParamsAndUpdateBalance", { troveId });
  return res.data.trove_params;
};

export const getTroveTextMessages = async (troveId: string): Promise<TextMessage[]> => {
  const res = await axios.post("/api/getTroveTextMessages", { troveId });
  return res.data.texts || [];
};

export const setTroveParameters = (trove: Trove) => axios.post("/api/setTroveParameters", { trove });

// cents must be an integer; the backend asserts it.
export const makeManualTrovePayment = (customerId: string, troveId: string, cents: number) =>
  axios.post("/api/makeManualTrovePayment", { customer: customerId, trove: troveId, cents });
